var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOoki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.39 23.41A10.004 10.004 0 0 0 21 14a9.96 9.96 0 0 0-.987-4.337A8.485 8.485 0 1 1 14.39 23.41zm4.796-15.155A9.988 9.988 0 0 0 11 4C5.477 4 1 8.477 1 14s4.477 10 10 10c.62 0 1.226-.056 1.814-.164A9.988 9.988 0 0 0 21 28.09c5.523 0 10-4.476 10-10 0-5.522-4.477-10-10-10-.62 0-1.226.057-1.814.165z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOoki);
export default __webpack_public_path__ + "static/media/OOKI.9e885bf4e79bc8a12eba13bd5e08cd85.svg";
export { ForwardRef as ReactComponent };